module.exports = __webpack_public_path__ + "img/gb-nir.5530407.svg";